import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'
import type * as Types from './type'

const initialState: Types.CaptchaType = {
  inCaptchaing: false,
}

/**
 * 任务中心
 */

const CaptchaSlice = createSlice({
  name: 'captcha',
  initialState: initialState,
  reducers: {
    setCaptchaStatus(state, action: PayloadAction<boolean>) {
      const status = action.payload
      return {
        ...state,
        inCaptchaing: status,
      }
    },
  },
})

export const { setCaptchaStatus } = CaptchaSlice.actions

export default CaptchaSlice.reducer
